<mat-card *ngIf="!data || !data.length" class="empty-card">
  <p class="uk-text-body">Aplica los filtros para ver los resultados</p>
</mat-card>

<mat-accordion class="card-list">
  <mat-expansion-panel
    *ngFor="let element of data; let i = index"
    class="mb-2"
    (opened)="viewRecord(element)"
    [disabled]="disableExpandable"
  >
    <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto">
      <ng-container *ngFor="let item of schema.items">
        <mat-form-field *ngIf="!item.onFooter" [ngClass]="item.class">
          <mat-label>{{ item.title }}</mat-label>
          <input
            matInput
            [id]="id + 'CardList-' + item.name"
            [value]="item.value(element)"
            readonly
          />
          <mat-icon *ngIf="item['icon']" matSuffix [svgIcon]="item['icon']" (click)="openAccion(element)"></mat-icon>
        </mat-form-field>
        <div
          *ngIf="item.onFooter"
          [id]="id + 'CardList-' + item.name"
          class="footer"
        >
          <span>{{ item.title }}: {{ item.value(element) }}</span>
          <div class="icon-action">
            <span *ngFor="let ico of schema.iconFooter">
              <div *ngIf="hiddenIcon(ico, element)">
                <mat-icon
                  *ngIf="ico.icon"
                  class="m-1 icon-primary"
                  (click)="onClickIconFooter(ico, element, i)"
                  >{{ ico.icon }}</mat-icon
                >
                <mat-icon
                  *ngIf="ico.iconSVG"
                  class="me-3 icon-primary"
                  [svgIcon]="ico.iconSVG"
                  (click)="onClickIconFooter(ico, element, i)"
                >
                </mat-icon>                
              </div>
            </span>
          </div>
          <mat-checkbox
            *ngIf="schema['checkbox']"
            class="check"
            [(ngModel)]="checkList[i]"
            (change)="changeCheck(checkList[i], i)"
            [disabled]="hasDisableCheckbox(element)"
          >
          </mat-checkbox>
        </div>
      </ng-container>
    </mat-expansion-panel-header>
    <div class="detail-header">
      <span>
        <span
          *ngIf="schema.detailQuantity && expandableData"
          [id]="id + 'CardList-quantity'"
        >
          Cantidad de productos: {{ expandableData?.length }}
        </span>
      </span>
      <span>
        <ng-container *ngIf="showActionIcons">
          <ng-container *ngFor="let item of schema.actionIcons"
            ><!-- *ngIf="item.indexOf('none')" -->
            <button
              mat-icon-button
              [id]="id + 'CardList-action-icons-' + item"
              (click)="iconHeader(item.icon)"
              [hidden]="isDisabledIconHeader(item)"
            >
              <mat-icon class="icon-table" [svgIcon]="item['icon']"></mat-icon>
            </button>
          </ng-container>
        </ng-container>
      </span>
    </div>
    <ng-container [ngSwitch]="schema.expandableType">
      <ng-container *ngSwitchCase="'ProductCard'">
        <app-product-card
          *ngFor="let element of expandableData; let i = index"
          [data]="element"
          [entityCode]="getEntityCode(element.orderId)"
          (select)="selectElement($event, element, i)"
        ></app-product-card>
      </ng-container>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>

<app-card-list-footer
  *ngIf="schema.footerAction && data?.length > 0"
  (isSubmit)="submit($event)"
  (totalSelection)="totalSelection($event)"
  [checkboxIcon]="schema['checkboxIcon']"
  [enabledIcons]="dataCheckConfirm?.length > 0 ? false : true"
>
</app-card-list-footer>
